export const categories = [
  {
    slug: 'pet-training',
    name: '宠物调教',
    description: '科学训犬、猫咪行为矫正及各类宠物训练方法，从基础指令到高级行为塑造',
    icon: 'ri-heart-pulse-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20indoor%20scene%20with%20a%20well-behaved%20golden%20retriever%20sitting%20calmly%20next%20to%20training%20props%20like%20clicker%20and%20treats%20on%20a%20light%20wooden%20floor%2C%20soft%20natural%20window%20light%2C%20clean%20aesthetic%20composition%2C%20editorial%20pet%20photography%20style%20with%20gentle%20shadows%20and%20harmonious%20neutral%20tones&width=640&height=440&seq=category-pet-training&orientation=landscape',
    articleCount: 24,
  },
  {
    slug: 'skill-training',
    name: '技能调教训练',
    description: '运动技能、专业技能与才艺培养的系统化训练方法与进阶路径',
    icon: 'ri-focus-3-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20artistic%20minimalist%20practice%20room%20scene%20with%20a%20musical%20instrument%20and%20training%20equipment%20arranged%20neatly%20on%20warm%20wooden%20surfaces%2C%20soft%20diffused%20lighting%20from%20large%20windows%2C%20clean%20modern%20aesthetic%2C%20editorial%20photography%20style%20with%20gentle%20shadows%20and%20balanced%20composition&width=640&height=440&seq=category-skill-training&orientation=landscape',
    articleCount: 18,
  },
  {
    slug: 'behavior-modification',
    name: '行为调教技巧',
    description: '行为矫正与习惯重塑的心理学方法，正强化训练与负面行为消除策略',
    icon: 'ri-mental-health-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20serene%20minimalist%20therapy%20room%20with%20comfortable%20seating%20arrangement%20and%20subtle%20decorative%20elements%20on%20warm%20neutral%20surfaces%2C%20soft%20ambient%20lighting%20creating%20calm%20atmosphere%2C%20clean%20aesthetic%20composition%2C%20editorial%20interior%20photography%20style%20with%20gentle%20shadows%20and%20peaceful%20mood&width=640&height=440&seq=category-behavior-modification&orientation=landscape',
    articleCount: 21,
  },
  {
    slug: 'self-improvement',
    name: '自我调教提升',
    description: '自律养成、习惯管理、时间规划等个人成长领域的自我调教方法与实践',
    icon: 'ri-user-star-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20home%20office%20scene%20with%20a%20neat%20desk%20setup%20featuring%20journals%20planners%20and%20a%20laptop%2C%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20clean%20modern%20aesthetic%2C%20editorial%20lifestyle%20photography%20with%20soft%20shadows%20and%20organized%20composition&width=640&height=440&seq=category-self-improvement&orientation=landscape',
    articleCount: 16,
  },
  {
    slug: 'education-training',
    name: '教育调教方法',
    description: '儿童行为引导、学习习惯培养及教育场景中的调教策略与沟通技巧',
    icon: 'ri-book-open-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20bright%20minimalist%20classroom%20or%20study%20space%20with%20educational%20materials%20and%20books%20arranged%20on%20light%20wooden%20surfaces%2C%20warm%20natural%20daylight%20creating%20inviting%20atmosphere%2C%20clean%20aesthetic%20composition%2C%20editorial%20photography%20style%20with%20soft%20shadows%20and%20educational%20mood&width=640&height=440&seq=category-education-training&orientation=landscape',
    articleCount: 15,
  },
  {
    slug: 'strategy-guide',
    name: '调教策略指南',
    description: '综合性的调教方法论、经典理论模型与跨领域应用策略深度解析',
    icon: 'ri-compass-3-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20artistic%20minimalist%20library%20scene%20with%20stacked%20books%20and%20strategic%20planning%20tools%20on%20warm%20wooden%20surfaces%2C%20soft%20natural%20lighting%20from%20tall%20windows%2C%20sophisticated%20clean%20aesthetic%2C%20editorial%20photography%20style%20with%20deep%20shadows%20and%20intellectual%20mood&width=640&height=440&seq=category-strategy-guide&orientation=landscape',
    articleCount: 12,
  },
];